import { commonRequestData, fetchData } from "../../api";

/**
 * Obtiene la lista de contratos llamando al endpoint correspondiente de la API.
 *
 * @param {Array} estados - Lista opcional de estados para filtrar los contratos.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API, que contiene la lista de contratos.
 */
export const obtenerLista_Contratos = async ({ estados }) => {
    // Prepara los datos para la solicitud combinando datos comunes y el filtro de estados
    const requestData = {
        ...commonRequestData, // Datos comunes como autenticación o configuraciones estándar
        estados, // Filtro opcional basado en el estado de los contratos
    };

    // Realiza la solicitud al endpoint "Contratos/lista" para obtener la lista de contratos
    const response = await fetchData("Contratos/lista", requestData);

    // Devuelve la respuesta completa obtenida de la API
    return response;
};

/**
 * Obtiene los detalles de un contrato específico a través de su identificador.
 *
 * @param {Object} ids - Identificadores del contrato a recuperar.
 * @returns {Promise<Object>} Promesa que resuelve con los detalles del contrato.
 */
export const obtenerContrato = async ({ ids }) => {
    // Prepara los datos de la solicitud combinando datos comunes y el identificador del contrato
    const requestData = {
        ...commonRequestData, // Datos comunes necesarios para la solicitud
        ids, // Identificadores utilizados como filtro en la solicitud
    };

    // Realiza la solicitud al endpoint "Contratos/obtenerId" para obtener los detalles del contrato
    const response = await fetchData("Contratos/obtenerId", requestData);

    // Devuelve la respuesta obtenida de la API
    return response;
};

/**
 * Obtiene el número consecutivo del contrato desde la API.
 *
 * @returns {Promise<Object>} Promesa que resuelve con el número consecutivo del contrato.
 */
export const obtener_NumeroConsecutivoContrato = async () => {
    // Prepara los datos para la solicitud combinando información común
    const requestData = {
        ...commonRequestData, // Datos comunes necesarios para la solicitud
    };

    // Realiza la solicitud al endpoint "Contratos/obtenerConsecutivo"
    const response = await fetchData("Contratos/obtenerConsecutivo", requestData);

    // Devuelve la respuesta obtenida de la API
    return response;
};

/**
 * Crea un contrato utilizando los datos completos proporcionados.
 *
 * @param {Object} datosCompletos - Datos necesarios para crear el contrato.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API tras crear el contrato.
 */
export const crearContratonApi = async ({ datosCompletos }) => {
    try {
        // Prepara los datos de la solicitud combinando información común y específica
        const requestData = {
            ...commonRequestData, // Datos comunes como autenticación o configuraciones generales
            datosCompletos, // Datos específicos para crear el contrato
        };

        // Realiza la solicitud al endpoint "Contratos/crearContrato"
        const response = await fetchData("Contratos/crearContrato", requestData);

        // Retorna la respuesta de la API con los datos del contrato creado
        return response;
    } catch (error) {
        // Maneja errores durante la creación del contrato y los registra
        console.error("Error al crear el contrato:", error.message || error);
        throw new Error("No se pudo crear el contrato. Verifique los detalles de la solicitud.");
    }
};

/**
 * Elimina un contrato específico utilizando su identificador.
 *
 * @param {Object} id - Identificador único del contrato a eliminar.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API tras eliminar el contrato.
 */
export const deleteEliminarContrato = async ({ id }) => {
    // Prepara los datos para la solicitud combinando información común y el ID del contrato
    const requestData = {
        ...commonRequestData, // Datos comunes como autenticación y configuración predeterminada
        id, // Identificador único del contrato a eliminar
    };

    // Realiza la solicitud al endpoint "Contratos/eliminarContrato"
    const response = await fetchData("Contratos/eliminarContrato", requestData);

    // Retorna la respuesta completa de la API con los resultados de la operación
    return response;
};
